import React, { Component } from 'react'
import Paper from '@mui/material/Paper'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

// const styles = theme => ({
//     root: theme.mixins.gutters({
//         paddingTop: 16,
//         paddingBottom: 16,
//         marginTop: theme.spacing.unit * 3,
//         marginLeft: 0,
//         textAlign: "center"
//     }),
//     Answer: {
//         background: "#ccffcc"
//     }
// });



class TAT extends Component {
    render() {
        return (
            <div>
                < AppBar position="static"
                    style={
                        {
                            marginLeft: 260,
                            backgroundColor: "#55565A",
                            fontFamily: ['Sans-Serif'],
                        }
                    } >
                    <Toolbar>
                        <Typography variant="h5" >
                            Tips & Tricks
                        </Typography>
                    </Toolbar>
                </AppBar>
                {
                    this.props.tats.map(n => {
                        return (
                            <Paper style={{ marginLeft: 260, fontFamily: ['Sans-Serif'] }} key={n.id}>
                                < Accordion >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        {decodeURIComponent(n.question)}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={{ color: 'black', fontFamily: ['Sans-Serif'],background: "white" }}>
                                            {decodeURIComponent(n.answer)}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion >
                            </Paper>
                        )
                    })
                }
            </div>
        )
    }
}


export default TAT
